/**
 * 결함 정보 다이얼로그 데이터 로드 접근 경로.
 * openDefectInfoDialog 진입 시 어떤 API·폼 초기화가 필요한지 구분한다.
 */
export const DefectDialogAccessMode = {
  /** 이미지 선택 — 새 결함 */
  NEW: 'new',
  /** 지도 마커 — 결함 스냅샷이 이미 완전함 */
  EDIT_FROM_MAP: 'edit_from_map',
  /** 목록 행 — id만 있거나 상세 재조회 필요 */
  EDIT_FROM_LIST: 'edit_from_list',
  /** 목록만 표시(showList), 폼 초기화 없음 */
  VIEW_LIST: 'view_list'
};

export function hasCompleteDefectSnapshot(defect) {
  return !!(defect && defect.id && defect.defectCode && defect.defectStatus);
}

/**
 * @param {{ isDefectSelected?: boolean, defect?: object|null, showList?: boolean }} params
 */
export function resolveDefectDialogAccessMode({
  isDefectSelected,
  defect,
  showList
}) {
  if (showList && !isDefectSelected) {
    return DefectDialogAccessMode.VIEW_LIST;
  }
  if (!isDefectSelected) {
    return DefectDialogAccessMode.NEW;
  }
  if (hasCompleteDefectSnapshot(defect)) {
    return DefectDialogAccessMode.EDIT_FROM_MAP;
  }
  return DefectDialogAccessMode.EDIT_FROM_LIST;
}
